// Src
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Types
type VersionState = {
    build?: number;
    version?: string;
};

const initialState: VersionState = {};

const versionSlice = createSlice({
    name: 'version',
    initialState,
    reducers: {
        updateVersionAction(state, action: PayloadAction<VersionState>) {
            state.build = action.payload.build;
            state.version = action.payload.version;
            return state;
        },
    },
});

export const { updateVersionAction } = versionSlice.actions;

export default versionSlice.reducer;
